import React from 'react';
import { IntlProvider } from 'react-intl';

import type { Locale } from '@swf/generated/graphql/poker/MTT/schemas';

import messages from './messages';

const TestIntlProvider = ({
  component: Component,
  locale
}: {
  component: React.FC;
  locale: Locale;
}) => (
  <IntlProvider locale={locale} messages={messages[locale as keyof typeof messages]}>
    <Component />
  </IntlProvider>
);

export default TestIntlProvider;
